// Exakter Wortlaut des Impressums
export const IMPRINT_SECTIONS = [
  {
    title: "Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)",
    blocks: [
      [
        "SBO Commerce",
        "Einzelunternehmen",
        "Inhaber: Sinan Boztepe",
        "Rosmarinweg 45",
        "86156 Augsburg",
        "Deutschland",
      ],
    ],
  },
  {
    title: "Kontakt",
    blocks: [["Telefon: +49 1556 7304351", "E-Mail: info@vision-one.io"]],
  },
  {
    title: "Verbraucherstreitbeilegung",
    blocks: [
      "Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
    ],
  },
  {
    title: "Haftung für externe Links",
    blocks: [
      "Diese Website kann Links zu externen Websites Dritter enthalten. Auf die Inhalte dieser externen Websites haben wir keinen Einfluss.",
      "Für die Inhalte der verlinkten Seiten sind grundsätzlich die jeweiligen Anbieter oder Betreiber verantwortlich. Bei Bekanntwerden konkreter Rechtsverletzungen werden wir entsprechende Links unverzüglich entfernen.",
    ],
  },
  {
    title: "Urheberrecht",
    blocks: [
      "Die auf dieser Website veröffentlichten Inhalte und Werke, insbesondere Texte, Fotografien, Grafiken, Designs, Layouts, Logos und Dateien, unterliegen, soweit sie urheberrechtlich geschützt sind, dem deutschen Urheberrecht.",
      "Die Vervielfältigung, Bearbeitung, Verbreitung, öffentliche Zugänglichmachung oder sonstige Verwertung außerhalb der gesetzlichen Grenzen des Urheberrechts bedarf der vorherigen Zustimmung des jeweiligen Rechteinhabers.",
      "Soweit Inhalte auf dieser Website nicht vom Betreiber erstellt wurden, werden die Rechte Dritter beachtet. Sollten Sie dennoch auf eine mögliche Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden die betreffenden Inhalte unverzüglich entfernt.",
    ],
  },
];
